<template lang="pug">
.profile-card
    .card(v-if="profile.profile")
        .card-body
            ImageCircle(:src="type === 'Course' ? profile.data.profileImg : profile.profile.photo" :type="type")
            p.m-0(style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;")
                UserName(:id="id" style="font-weight: bold")
            p.small(style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;") {{profile.profile.description}}
            .row
                .col.s-6
                    FollowButton(:profile="profile")
                .col.s-6(v-if="type !== 'User'")
                    span.material-icons hail
                    span {{Object.keys(profile.subscribed).length}}
</template>

<script>
import API from "./../API.js";
import ImageCircle from "./fundamentals/ImageCircle.vue";
import UserName from "./UserName.vue";
import FollowButton from "./fundamentals/FollowButton.vue";
import { UserStore } from "./../UserStore.js";

export default {
  name: "ProfileCard",
  props: ["id"],
  components: {ImageCircle, UserName, FollowButton},
  data() {
    return {
      profile: {},
      UserStore
    };
  },
  mounted() {
    this.refresh(this.id);
  },
  methods: {
    goToProfile() {
      this.$router.push("/feed/" + this.id);
    },
    refresh(id) {
      API.getUserProfile(id).then((data) => {
        this.profile = data;
      });
    },
  },
  computed:{
    type(){
      return this.profile.isGroup ? (this.profile.isCourse ? 'Course' : 'Group') : 'User';
    },
  }
};
</script>

<style lang='sass' scoped>
</style>